import Kid1 from "../assets/images/Kid1.png";
import Kid2 from "../assets/images/Kid2.png";
import Kid3 from "../assets/images/Kid3.png";
import Kid4 from "../assets/images/Kid4.png";

export const children = [
  { pic: Kid1, percent: "45%", nationality: "White" },
  { pic: false },
  { pic: Kid2, percent: "23%", nationality: "Hispanic" },
  { pic: Kid3, percent: "18%", nationality: "Black" },
  { pic: Kid4, percent: "19%", nationality: "Native" }
];
